import AccountAssignmentComponent from "../components/AccountAssignment/AccountAssignment";

function AccountAssignmentPage() {
  return <AccountAssignmentComponent />;
}

export default AccountAssignmentPage;
